import { CircularProgress, Grid, Paper, Typography } from '@material-ui/core'
import React, { useEffect, useMemo, useState } from 'react'
import { Chart } from './Chart'
import { GroupButtonChart } from './GroupButtonChart'
import { useDispatch, useSelector } from 'react-redux'
import { deepAnaliticsSelector, loadingChartDeepAnalitics } from '../../redux/reducers/chart-deep-analitics'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const listChart = {
    KPI: 'показатель эффективности (К)',
    n: 'Количество проверок (N)',
    w: 'Тяжесть нарушений (W)',  
    r: 'Количество повторов (R)',
    t: 'Неустранённость нарушений (T)',
    NPT: 'Непроизводительное время (NPT)',
}

const listChartEl = [
    'KPI',
    'n',
    'w', 
    'r',
    't',
    'NPT'
]
    
export const ChartDeepAnalitics = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const {data, loading, error} = useSelector(deepAnaliticsSelector)


    useEffect(() => {
        const name = location.pathname.split('/').at(-1)
        dispatch(loadingChartDeepAnalitics({
            name: name,
            startTime: '2022-10-01',
            endTime: "2023-10-25", 
            localCompany: localStorage.getItem('companies'),
            contractName: localStorage.getItem('contractName'),
            interval: 'month',
        }))
    }, [dispatch, location.pathname])
    
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} >
                <GroupButtonChart />
            </Grid>
            {JSON.stringify(data) !== '[]' && !loading && error === null  
            
                ? listChartEl.map((pokaz, index) => (
                    <Grid item xs={4} key={`chart-${pokaz}`}>
                        <Chart
                            keyName={pokaz} 
                            name={listChart[pokaz]}
                            pokaz={data[pokaz]}
                        />
                    </Grid>

                ))
                : loading
                    ? <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">
                        <CircularProgress
                            style={{
                                width: '100px',
                                height: '100px',
                                marginTop: '100px'
                            }}
                        />
                        </Grid> 
                    : <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">
                        <Typography
                            variant='h5'
                            style={{
                                color: 'red',
                                marginTop: '100px'
                            }}
                        >{error}</Typography>
                        </Grid> 
            }
        </Grid>
    )
}
